import { FunctionComponent } from 'react';
import { iconMap, Icons } from './icons';

import styles from './Icon.module.scss';

export type { Icons } from './icons';
export type Color =
  | 'primary-purple'
  | 'primary-dark'
  | 'medium-dark'
  | 'primary-light'
  | 'primary-dark-transparent'
  | 'medium-light'
  | 'medium-grey'
  | 'low-light'
  | 'error'
  | 'none'
  | 'grey'
  | 'purple'
  | 'greyLight'
  | 'blue'
  | 'green'
  | 'dark-grey';

export interface IconProps {
  icon?: Icons;
  color?: Color;
  bgColor?: Color;
  size?: 'xsm' | 'sm' | 'md' | 'lg' | 'xlg' | 'xxlg' | 'jumbo' | 'xl-jumbo' | 'logo';
  width?: string;
  height?: string;
  disabled?: boolean;
  position?: 'left' | 'right' | 'center' | 'start' | 'end';
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
}

type FC = FunctionComponent<IconProps>;

const Icon: FC = ({
  icon = 'vLogo',
  color = 'primary-dark',
  bgColor = 'primary-light',
  size = 'md',
  width,
  height,
  disabled = false,
  position = 'center',
  onClick,
  className,
}) => {
  return (
    <div
      className={[
        styles.Icon,
        styles[`bg--${bgColor}`],
        styles[`bg--${size}`],
        styles[getPositionClass()],
        styles[getDisabledClass()],
        className,
      ].join(' ')}
      style={{ width, height }}
    >
      {onClick ? (
        <button onClick={onClick} type="button">
          <img
            className={[styles[`icon--${size}`], styles[`icon--${color}`]].join(' ')}
            src={iconMap[icon].src}
            alt={iconMap[icon].alt}
            style={{ width, height }}
          />
        </button>
      ) : (
        <img
          className={[styles[`icon--${size}`], styles[`icon--${color}`]].join(' ')}
          src={iconMap[icon].src}
          alt={iconMap[icon].alt}
          style={{ width, height }}
        />
      )}
    </div>
  );

  function getPositionClass() {
    return `position--${position}`;
  }
  function getDisabledClass() {
    return disabled ? 'disabled' : '';
  }
};

export default Icon;
